module.exports = __webpack_public_path__ + "static/media/M14ws.0812e66c.pdf";